export const LogoMark = ({ size = 44 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="2" width="60" height="60" rx="4" stroke="#D4AF37" strokeWidth="1.5" />
    <rect x="7" y="7" width="50" height="50" rx="2" stroke="#D4AF37" strokeWidth="0.5" opacity="0.4" />
    <path d="M20 46V18h13c5 0 9 3.4 9 8.2 0 3.9-2.6 6.8-6.2 7.8L44 46h-6.4l-7.4-11h-4.5v11H20Zm5.7-15.7h6.8c2.6 0 4.6-1.7 4.6-4.1 0-2.4-2-4-4.6-4h-6.8v8.1Z" fill="#D4AF37" />
    <rect x="46" y="8" width="3" height="9" fill="#D4AF37" />
    <rect x="43" y="11" width="9" height="3" fill="#D4AF37" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <div className="flex items-center gap-3">
    <LogoMark size={40} />
    <div className="leading-tight">
      <div className={`font-serif text-lg tracking-wide ${light ? "text-slate-50" : "text-slate-900"}`}>
        Risc Goup <span className="text-[#D4AF37]">Suisse</span> SA
      </div>
      <div className="text-[9px] uppercase tracking-[0.3em] text-slate-400 font-mono">Audit · Révision · Conseil</div>
    </div>
  </div>
);
